import React from 'react';
import Grid from '@mui/material/Grid2';
import DashboardButton from './DashboardButton';
import Typography from '@mui/material/Typography';
import { 
  ChildCare, 
  ContentCutRounded, 
  WaterDrop, 
  Face, 
  Tune, 
  LocalFlorist 
} from '@mui/icons-material'; // Importing icons from Material UI

const services = [
  { name: "Kinderhaarschnitt (bis 11 Jahre)", icon: <ChildCare fontSize="large" />, price: 13 },
  { name: "Kinderhaarschnitt (bis 13 Jahre)", icon: <ChildCare fontSize="large" />, price: 15 },
  { name: "Trockenschnitt", icon: <ContentCutRounded fontSize="large" />, price: 18 },
  { name: "NassHaarschnitt", icon: <WaterDrop fontSize="large" />, price: 21 },
  { name: "Kopfrasur", icon: <Face fontSize="large" />, price: 18 },
  { name: "Bart", icon: <LocalFlorist fontSize="large" />, price: 13 },
  { name: "Komplett Service", icon: <Tune fontSize="large" />, price: 28 },
];

const ServiceSelection = ({ selectedServices, handleServiceSelection }) => {
  return (
    <>
      <Typography component="h2" variant="h6" sx={{ mb: 3, fontWeight: 500 }}>
        Select a Service
      </Typography>
      <Grid container spacing={3} sx={{ mb: 5 }}>
        {services.map((service) => (
         <Grid
              size={{ xs: 6, sm: 12 }} // 2 per row on mobile, full width on sm+
              key={service.name}
              sx={{ 
                display: { sm: 'inline-flex' }, // Remove Grid styling on larger screens
                maxWidth: { sm: '200px' } // Match DashboardButton's sm width
              }}
            >
            <DashboardButton
              text={`${service.name}`}
              secondaryText={`€${service.price}`}
              icon={service.icon}
              selected={selectedServices.some(item => item.name === service.name)}  // Check if service is in selectedServices array
              onClick={() => handleServiceSelection(service)}  // Pass the entire service object
              size="small"
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ServiceSelection;
